import { useData } from "context/data.context";
import { CLASS_LABELS } from 'utilities/global.variables';
import TableRowCard from "./table.row.card";

const TableView = ({isAsset, editEntry}) => {
  const { networthCurrent } = useData();
  const classes = isAsset ? networthCurrent.assets.classes : networthCurrent.liabilities.classes;

  return (
    <>
      {classes.map(({ name, items }) => (
        <div key={name} className="card flex col ">
          <div>
            <div className="flex row center large-gap">
              <p className="regular"> {CLASS_LABELS[name] ?? name} </p>
            </div>
          </div>
          <div className="table-group margin-top-large ">
            {items.map((item) => (
              <TableRowCard key={item.id} item={item} isAsset={isAsset} editEntry={editEntry} />
            ))}
          </div>
        </div>
      ))}
    </>
  );
};

export default TableView;
